import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class HomeCrosstalk {
  constructor() {
    this.DOM = {};
    this.DOM.section = document.querySelector('[data-home-crosstalk]');
    if (!this.DOM.section) return;

    this.DOM.bg = this.DOM.section.querySelector('[data-home-crosstalk-element="bg"]');
    this.DOM.head = this.DOM.section.querySelector('[data-home-crosstalk-element="head"]');
    this.DOM.items = this.DOM.section.querySelectorAll('[data-home-crosstalk-element="item"]');

    this.init();
  }

  init() {
    this.setupBg();
    this.setupFade(this.DOM.head);
    this.DOM.items.forEach((item) => this.setupFade(item));

    window.addEventListener('load', () => {
      ScrollTrigger.refresh();
    }, { once: true });
  }

  setupBg() {
    if (!this.DOM.bg) return;

    gsap.fromTo(
      this.DOM.bg,
      { scale: 0 },
      {
        scale: 1,
        transformOrigin: 'top center',
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: this.DOM.section,
          start: 'top 85%',
          once: true,
        },
      }
    );
  }

  setupFade(el) {
    if (!el) return;

    gsap.fromTo(
      el,
      { opacity: 0, y: 16 },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true,
        },
      }
    );
  }
}
